import request from '@/utils/request';
export const defaultDealersAddressData = {
  id: 0,
  enabled: true,
  isPrimary: false,
  isPostal: false,
  name: '',
  gstNumber: undefined,
  panNumber: undefined,
  line1: '',
  line2: '',
  cityName: null,
  countryId: null,
  country: {
    id: null
  },
  stateId: null,
  state: {
    id: null
  },
  cityId: null,
  city: {
    id: null
  },
  pincodeId: null,
  pincode: {
    id: null
  },
  dealerId: 0,
  dealer: {
    id: null
  }
};
export const getDealersAddresses = params => request({
  url: '/dealers-addresses',
  method: 'get',
  params
});
export const getDealersAddressesById = id => request({
  url: `/dealers-addresses/${id}`,
  method: 'get'
});
export const updateDealersAddresses = (id, data) => request({
  url: `/dealers-addresses/${id}`,
  method: 'patch',
  data
});
export const deleteDealersAddresses = id => request({
  url: `/dealers-addresses/${id}`,
  method: 'delete'
});
export const createDealersAddresses = data => request({
  url: '/dealers-addresses/',
  method: 'post',
  data
});
export const downloadEnvelopePdf = id => request({
  url: `/dealers-addresses/download-envelope-pdf/${id}`,
  method: 'get'
});